import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import AccountActivation from '../components/AccountActivation';
import ActivationKey from '../components/ActivationKey';
import EmailActivation from '../components/EmailActivation';
import ForgotPassword from '../components/ForgotPassword';
import ResetPassword from '../components/ResetPassword';
import ResetPasswordForm from '../components/ResetPasswordForm';

import { AccountVerify } from './AccountVerify';
import { Login } from './Login';
import { Register } from './Register';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route
        path="/sign-up"
        element={
          <RouteWithTitle title="Sign Up - Wisestep">
            <Register />
          </RouteWithTitle>
        }
      />
      <Route
        path="/"
        element={
          <RouteWithTitle title="Login in- Wisestep">
            <Login />
          </RouteWithTitle>
        }
      />
      <Route
        path="/verify-account"
        element={
          <RouteWithTitle title="Account Verify- Wisestep">
            <AccountVerify />
          </RouteWithTitle>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <RouteWithTitle title="Forgot Password- Wisestep">
            <ForgotPassword />
          </RouteWithTitle>
        }
      />
      <Route
        path="/reset-initiated"
        element={
          <RouteWithTitle title="Reset Password- Wisestep">
            <ResetPassword />
          </RouteWithTitle>
        }
      />
      <Route
        path="/account-activation"
        element={
          <RouteWithTitle title="Account Activation- Wisestep">
            <EmailActivation />
          </RouteWithTitle>
        }
      />
      <Route
        path="/resend-key"
        element={
          <RouteWithTitle title="Resend Key- Wisestep">
            <ActivationKey />
          </RouteWithTitle>
        }
      />
      <Route
        path="/reset-password"
        element={
          <RouteWithTitle title="Reset Password Form- Wisestep">
            <ResetPasswordForm />
          </RouteWithTitle>
        }
      />
      <Route
        path="/activate"
        element={
          <RouteWithTitle title="Account Activation- Wisestep">
            <AccountActivation />
          </RouteWithTitle>
        }
      />
    </Routes>
  );
};
